import { FC } from "react";
import CategoryStatusTable from "../CategoryStatusTable";
import useCompanyPoliciesCategoryStatus, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

const CompanyPoliciesCategoryStatusLayout: FC<Props> = () => {
  return (
    <Styles>
      <CategoryStatusTable screen="company_policies" recordType="status" />
      <CategoryStatusTable screen="company_policies" recordType="category" />
    </Styles>
  );
};

const CompanyPoliciesCategoryStatus: FC<ReceivedProps> = (props) => (
  <CompanyPoliciesCategoryStatusLayout
    {...useCompanyPoliciesCategoryStatus(props)}
  />
);

export default CompanyPoliciesCategoryStatus;
